var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfileVerifiedIcon = function SvgProfileVerifiedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 31,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00AC75",
    d: "M32 15.313c0 1.628-2.038 2.914-2.515 4.382-.494 1.522.382 3.757-.54 5.024-.931 1.28-3.334 1.132-4.613 2.064-1.267.922-1.864 3.257-3.387 3.751-1.468.477-3.317-1.046-4.945-1.046s-3.477 1.523-4.945 1.046c-1.522-.494-2.12-2.83-3.387-3.751-1.28-.932-3.682-.785-4.613-2.064-.922-1.267-.046-3.502-.54-5.024C2.038 18.227 0 16.941 0 15.313s2.038-2.913 2.515-4.382c.494-1.522-.382-3.756.54-5.023.931-1.28 3.334-1.133 4.613-2.064C8.935 2.922 9.533.587 11.055.092 12.523-.384 14.372 1.138 16 1.138S19.477-.384 20.945.092c1.523.495 2.12 2.83 3.387 3.752 1.28.931 3.682.784 4.613 2.064.922 1.267.046 3.501.54 5.023.477 1.47 2.515 2.755 2.515 4.382"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.61 22.84-5.715-5.193 2.075-2.285 3.306 3.004 7.768-9.525 2.392 1.951z"
  })));
};
export default SvgProfileVerifiedIcon;